var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.85 25.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0c305d;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    className: "cls-1",
    x: 0.43,
    y: 0.43,
    width: 25,
    height: 25,
    rx: 6,
    ry: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_399"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.26,7.18c.19,0,.38.07.53.22l5,5c.29.29.29.77,0,1.06l-5,5c-.29.29-.77.29-1.06,0s-.29-.77,0-1.06l4.47-4.47-4.47-4.47c-.29-.29-.29-.77,0-1.06.15-.15.34-.22.53-.22Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_400"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.26,7.18c.19,0,.38.07.53.22l5,5c.29.29.29.77,0,1.06l-5,5c-.29.29-.77.29-1.06,0s-.29-.77,0-1.06l4.47-4.47-4.47-4.47c-.29-.29-.29-.77,0-1.06.15-.15.34-.22.53-.22Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.c8a7d068a93089c7b9bd0c0dcf566cbf.svg";
export { ForwardRef as ReactComponent };